import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import DesktopInformation from './Desktop';
import MobileInformation from './Mobile';
import useShouldRenderForDesktop from '@/hooks/layout/useShouldRenderForDesktop';
import useShouldRenderForMobile from '@/hooks/layout/useShouldRenderForMobile';

const SlateInformation = ({
  loading,
  loadingPlayButton,
  hidePlayButton,
  isPlaying,
  isPaused,
  hideShareButton,
  duration,
  title,
  genres,
  description,
  onClickPlay,
  onClickAdd,
  onClickShare,
  onClickInfo,
  showHref,
  style,
  hideDescription,
  seasonNumber,
  episodeNumber,
  isCurrentlyPlayingShow,
  releaseDate
}) => {
  const shouldRenderForMobile = useShouldRenderForMobile();
  const shouldRenderForDesktop = useShouldRenderForDesktop();

  const handleClickShare = useCallback((e) => {
    e.stopPropagation();

    onClickShare();
  }, [onClickShare]);
  
  const handleClickAdd = useCallback((e) => {
    e.stopPropagation();

    onClickAdd();
  }, [onClickAdd]);

  const handleClickPlay = useCallback((e) => {
    e.stopPropagation();

    onClickPlay(e);
  }, [onClickPlay]);

  const handleClickInfo = (e) => onClickInfo(e);

  const props = {
    loading,
    loadingPlayButton,
    hidePlayButton,
    isPlaying,
    isPaused,
    hideShareButton,
    duration,
    title,
    showHref,
    genres,
    description,
    style,
    seasonNumber,
    episodeNumber,
    isCurrentlyPlayingShow,
    onClickPlay: handleClickPlay,
    onClickAdd: onClickAdd ? handleClickAdd : undefined,
    onClickShare: onClickShare ? handleClickShare : undefined,
    onClickInfo: onClickInfo ? handleClickInfo : undefined,
    releaseDate
  };

  return (
    <>
      { shouldRenderForMobile && <MobileInformation { ...props } /> }
      { shouldRenderForDesktop && (
        <DesktopInformation
          { ...props }
          hideDescription={ hideDescription }
        />
      ) }
    </>
  );
};

SlateInformation.propTypes = {
  loading: PropTypes.bool,
  loadingPlayButton: PropTypes.bool,
  duration: PropTypes.number,
  title: PropTypes.string,
  description: PropTypes.string,
  genres: PropTypes.arrayOf(PropTypes.object),
  hidePlayButton: PropTypes.bool,
  isPlaying: PropTypes.bool,
  isPaused: PropTypes.bool,
  hideShareButton: PropTypes.bool,
  onClickPlay: PropTypes.func,
  onClickAdd: PropTypes.func,
  onClickShare: PropTypes.func,
  onClickInfo: PropTypes.func,
  style: PropTypes.object,
  hideDescription: PropTypes.bool,
  seasonNumber: PropTypes.number,
  episodeNumber: PropTypes.number,
  isCurrentlyPlayingShow: PropTypes.bool,
  showHref: PropTypes.string,
  releaseDate: PropTypes.string
};

SlateInformation.defaultProps = {
  loading: false,
  loadingPlayButton: false,
  onClickAdd: undefined,
  description: '',
  genres: [],
  onClickShare: undefined,
  onClickPlay: undefined,
  hidePlayButton: false,
  isPlaying: false,
  isPaused: false,
  hideShareButton: false,
  duration: null,
  onClickInfo: undefined,
  style: {},
  hideDescription: false,
  title: '',
  seasonNumber: 0,
  episodeNumber: 0,
  isCurrentlyPlayingShow: false,
  showHref: '',
  releaseDate: false
};

export default memo(SlateInformation);